import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { SectionHeading } from "../components/Section";
import { useLang } from "../i18n/LanguageContext";

const FAQS = {
  en: [
    ["How long does delivery take?", "Most EU orders arrive in 3\u20135 business days with free shipping."],
    ["Do you offer a warranty?", "Yes \u2014 every projector includes a 2-year warranty and 30-day returns."],
    ["Can I use it in a bright room?", "Look for higher ANSI lumens. Our advisor and simulator recommend the right brightness for your light."],
    ["Do projectors include speakers?", "All our models have built-in speakers; add a soundbar for a full cinema experience."],
    ["Can I resell or order in bulk?", "Absolutely \u2014 visit our Wholesale page to request partner pricing and dropshipping."],
  ],
  hr: [
    ["Koliko traje dostava?", "Većina EU narudžbi stiže za 3\u20135 radnih dana uz besplatnu dostavu."],
    ["Nudite li jamstvo?", "Da \u2014 svaki projektor uključuje 2 godine jamstva i povrat u 30 dana."],
    ["Mogu li ga koristiti u svijetloj sobi?", "Tražite veći broj ANSI lumena. Naš savjetnik i simulator preporučuju pravu svjetlinu za vaše svjetlo."],
    ["Imaju li projektori zvučnike?", "Svi naši modeli imaju ugrađene zvučnike; dodajte soundbar za potpuni kino doživljaj."],
    ["Mogu li preprodavati ili naručiti veću količinu?", "Naravno \u2014 posjetite stranicu Veleprodaja za partnerske cijene i dropshipping."],
  ],
};

const CONTENT = {
  about: { titleKey: "pages.aboutTitle", bodyKey: "pages.aboutBody" },
  shipping: { titleKey: "pages.shippingTitle", body: { en: "We ship across the EU with free delivery in 3\u20135 business days for most countries. Orders are tracked and insured. Returns are accepted within 30 days of delivery in original condition.", hr: "Šaljemo diljem EU uz besplatnu dostavu za 3\u20135 radnih dana za većinu zemalja. Narudžbe su praćene i osigurane. Povrat se prihvaća u roku od 30 dana od isporuke u izvornom stanju." } },
  warranty: { titleKey: "pages.warrantyTitle", body: { en: "Every projector includes a 2-year manufacturer warranty covering defects. Our support team is available 7 days a week to help with setup, calibration and troubleshooting.", hr: "Svaki projektor uključuje 2 godine proizvođačkog jamstva koje pokriva kvarove. Naš tim podrške dostupan je 7 dana u tjednu za pomoć oko postavljanja, kalibracije i rješavanja problema." } },
  privacy: { titleKey: "pages.privacyTitle", body: { en: "We respect your privacy. We only collect the data needed to process orders and improve your experience, and never sell your information. This is placeholder legal copy for the demo.", hr: "Poštujemo vašu privatnost. Prikupljamo samo podatke potrebne za obradu narudžbi i poboljšanje vašeg iskustva te nikada ne prodajemo vaše informacije. Ovo je zamjenski pravni tekst za demo." } },
  terms: { titleKey: "pages.termsTitle", body: { en: "By using this site you agree to our terms of service. Pricing, availability and specifications are subject to change. This is placeholder legal copy for the demo.", hr: "Korištenjem ove stranice prihvaćate naše uvjete korištenja. Cijene, dostupnost i specifikacije podložni su promjenama. Ovo je zamjenski pravni tekst za demo." } },
};

export default function StaticPage({ kind }) {
  const { t, lang } = useLang();
  if (kind === "faq") {
    return (
      <div className="pt-24 pb-16 container-lumeo max-w-3xl">
        <SectionHeading title={t("pages.faqTitle")} />
        <Accordion type="single" collapsible className="rounded-2xl card-ceramic px-5">
          {(FAQS[lang] || FAQS.en).map(([q, a], i) => (
            <AccordionItem key={i} value={`q${i}`} className="border-border">
              <AccordionTrigger className="text-left">{q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    );
  }
  const c = CONTENT[kind] || CONTENT.about;
  const body = c.bodyKey ? t(c.bodyKey) : (c.body[lang] || c.body.en);
  return (
    <div className="pt-24 pb-16 container-lumeo max-w-3xl">
      <SectionHeading title={t(c.titleKey)} center={false} />
      <div className="rounded-2xl card-ceramic p-8"><p className="text-foreground/80 leading-relaxed">{body}</p></div>
    </div>
  );
}
